module.exports = __webpack_public_path__ + "img/new_25_1.68479ebe.jpg";